import { render, staticRenderFns } from "./ContactsTab.vue?vue&type=template&id=3d9f5380&"
import script from "./ContactsTab.vue?vue&type=script&lang=js&"
export * from "./ContactsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports